import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { load, isProfileLoaded, resetProfileLoaded } from 'modules/HorseRacing/reducers/trainerProfile';

import { standardAsyncConnect } from 'utils/asyncConnectWrapper';

import { canonicalLink } from 'utils/seoUtils';
import { racingProfileLink } from 'modules/HorseRacing/utils';

import SwitchBtns from 'modules/Common/components/SwitchBtns';
import ProfileHeading from 'modules/HorseRacing/components/Profiles/ProfileHeading';

require('./TrainerProfilePage.scss');

@standardAsyncConnect([
  {
    dispatch: ({ params: { trainerId } }) => load(trainerId),
    preventResolve: ({ state }) => isProfileLoaded(state),
    state: state => ({ profile: state.horseRacing.trainerProfile.profile }),
    errorState: state => state.horseRacing.trainerProfile.error,
    refreshInterval: 60000,
    preserveRefresh: true,
    reset: () => resetProfileLoaded(),
    handleError: true,
    reportStatus: true
  }
])
export default class TrainerProfilePageContainer extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    profile: PropTypes.object,
    params: PropTypes.object,
    children: PropTypes.node.isRequired
  };

  render() {
    const {
      routes,
      children,
      profile,
      profile: {
        person_details: {
          name,
          person_reference: {
            id
          } = {}
        } = {}
      } = {}
    } = this.props;

    return (
      <div className="trainer-profile">
        <MetaDataWrapper helmetProps={{...canonicalLink(routes, {trainerId: id})}}/>
        <ProfileHeading classPrefix="trainer" type="TRAINER" {...{id, name}}/>
        <SwitchBtns buttons={[
          {href: racingProfileLink('trainer', id), isIndex: true, text: "All Results"},
          {href: `${racingProfileLink('trainer', id)}/future-entries`, text: "Future Entries"}
        ]}/>
        {children && React.cloneElement(children, { profile })}
      </div>
    );
  }

  renderError() {
    return (
      <div className="trainer-profile">
        <h1>Trainer not found</h1>
        <div className="trainer-profile-not-found">The trainer you were looking for could not be found</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/Profiles/TrainerProfilePageContainer.js